/* Utility function for stripping HTML tags from a given string. */

type TStripHtmlParams = {
    html: string | undefined;
    maxCharacters?: number;
};

export const stripHtml = ({ html, maxCharacters = 300 }: TStripHtmlParams) => {
    if (!html) {
        return undefined;
    }
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent?.slice(0, maxCharacters) || "";
};
